module.exports = "<ul>\n    <li ng-repeat=\"item in categories\" ng-click=\"topNav.selectCategory(item)\" ng-class=\"{'selected': item.selected}\">\n        <div>{{item.title}}</div>\n    </li>\n</ul>\n<div ng-if=\"topNav.descriptionVisible\" class=\"category-description\"><button ng-click=\"topNav.openCategoryModal(topNav.selectedCategory)\"></button><span ng-bind=\"topNav.categoryDescription\">Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, quisquam!</span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/app-nav/topNav.html
// module id = 394
// module chunks = 0